/* eslint-disable react/jsx-pascal-case */
import React from 'react'
import { Alert, Container, Form, Row, Col } from 'react-bootstrap'
import InputForm from './InputForm'
import ModalQuit from '../ModalQuit'
import AllModalsFooter from '../assets/AllModalsFooter'
import { SaveCurrentDataButton } from '../assets/BasicButtons'
import { createData } from './functionsForm'
import { isEqual } from 'lodash-es'

export default class Form_Seventeen extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      language: 'rus',
      dataValue: [],
      id: 1,
      maxId: 3,
      nameForm: 'Seventeen',
      dataOnServer: [],
      dataFromServer: [],
      lengthDataFromServer: 0,
      base: [],
      show: false,
      previousState: [],
      savedDataMessage: false,
      dataBeenSaved: false
    }

    this.doChangeValue = this.doChangeValue.bind(this)
    this.handleClickSave = this.handleClickSave.bind(this)
    this.handleClickShadow = this.handleClickShadow.bind(this)
    this.doChangeVisionBlock = this.doChangeVisionBlock.bind(this)
    this.doEmpty = this.doEmpty.bind(this)

    this.doQuitWithSave = this.doQuitWithSave.bind(this)
    this.doQuitWithoutSave = this.doQuitWithoutSave.bind(this)
    this.closeQuitModal = this.closeQuitModal.bind(this)
    this.compare = this.compare.bind(this)
    this.smartWindowFunction = this.smartWindowFunction.bind(this)
    this.saveDataWithNotification = this.saveDataWithNotification.bind(this)
  }

  saveDataWithNotification() {
    this.handleClickSave()

    this.setState({
      savedDataMessage: true,
      dataBeenSaved: true
    })
    setTimeout(() => {
      this.setState({
        savedDataMessage: false
      })
    }, 2000)
  }

  closeQuitModal() {
    this.setState({
      showQuit: false
    })
  }

  //*Пустышка
  doEmpty() {}

  //* меняем видимость блока при выборе ДА / НЕТ
  doChangeVisionBlock(data) {}

  //запуск выхода из формы
  handleClickShadow() {
    this.setState({ showQuit: true })
  }

  //выход с сохранением
  doQuitWithSave() {
    this.setState({ showQuit: false })
    this.handleClickSave()
    this.props.onChangeView('Seventeen')
  }
  //выход без сохранения
  doQuitWithoutSave() {
    this.setState({ showQuit: false })
    this.props.onChangeView('Seventeen')
  }

  //*формируем данные в массив объектов для отправки на сервер
  handleClickSave() {
    let data = this.state.dataOnServer

    for (let i = 0; i <= this.state.maxId; i++) {
      //todo создаем позицию с пустым объектом
      data[i] = { id: '', fid: '', description: '', information: '', value: '' }

      //todo заполняем объект данными с сервера
      this.state.dataFromServer.forEach((dataD) => {
        if (+dataD.id === i) {
          data[i] = { id: dataD.id, fid: dataD.fid, description: dataD.description, information: dataD.information, value: dataD.value }
        }
      })
      //todo заполняем объект данными с формы
      this.state.dataValue.forEach((dataE) => {
        if (+dataE.id === i) {
          data[i] = { id: dataE.id, fid: dataE.fid, description: dataE.description, information: dataE.information, value: dataE.value }
        }
      })
    }
    this.setState({ dataOnServer: data }) //todo проверка на наличие данных на сервере
    if (this.state.lengthDataFromServer < 1) {
      console.log('CREATE DATA')
      this.props.onCreateDataServer(data, 'Seventeen', localStorage.getItem('idUser'))
    } else {
      console.log('UPDATE DATA')
      this.props.onUpdateDataOnServer(data, 'Seventeen', localStorage.getItem('idUser'))
    }
    setTimeout(() => {
      console.log(this.state.dataOnServer)
    }) //test
    // this.handleClickShadow();
  }

  //* данные с полей формы, формируются в массив объектов
  doChangeValue(data) {
    console.log(data) //test
    this.setState({ dataValue: [...this.state.dataValue, data] })
    this.setState({
      dataBeenSaved: false
    })
  }

  compare() {
    const prev = this.state.previousState
    const curr = createData(this.state.dataOnServer, this.state.maxId, this.state.dataFromServer, this.state.dataValue)

    const isStateEqual = isEqual(prev, curr)
    if (isStateEqual) {
      return true
    }
    return false
  }

  smartWindowFunction() {
    const isStateEqual = this.compare()
    const { dataBeenSaved, dataValue } = this.state
    if (isStateEqual || dataBeenSaved || dataValue.length === 0) {
      this.props.onChangeView('Seventeen')
    } else {
      this.handleClickShadow()
    }
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({ dataFromServer: this.props.data, lengthDataFromServer: this.props.lengthDataFromServer })
    }, 1000)
    if (this.props.data.length) {
      const previousState = JSON.parse(JSON.stringify(this.props.data))
      this.setState({ previousState })
    }
  }

  render() {
    const view = this.props.view
    this.value = this.props.data
    const viewQuest = this.props.viewQuest

    // console.log(this.state.dataValue)

    return (
      <>
        {this.state.showQuit ? <ModalQuit onQuitWithSave={this.doQuitWithSave} onQuitWithoutSave={this.doQuitWithoutSave} closeQuitModal={this.closeQuitModal} /> : ''}

        <div className='modal_window' style={{ display: view ? 'block' : 'none' }}>
          <div
            className={viewQuest ? 'shadow_form' : 'shadow_form_off'}
            // onClick={this.handleClickShadow}
            onClick={this.smartWindowFunction}
          ></div>
          <Form className={viewQuest ? 'form_main' : 'form_main_view'}>
            <Alert
              variant='dark'
              className='form_alert'
              onClick={this.handleClickHeader}
              // onClose={() => this.handleClickShadow()}
              onClose={this.smartWindowFunction}
              dismissible
            >
              <Alert.Heading>Текущее состояние предприятия </Alert.Heading>
            </Alert>
            <div>
              <Container className='form_container'>
                <Form.Group>
                  <Row>
                    <Col>Информация о судебных процессах, в которых предприятие участвовало в качестве ответчика</Col>
                  </Row>
                  <Row>&nbsp; </Row>
                  <Row>
                    <InputForm
                      id={1}
                      width={12}
                      show={true}
                      // verify="number"
                      label=''
                      placeholder='Информация о судебных процессах'
                      description='Текущее состояние предприятия'
                      value={this.value[1] ? this.value[1].value : ''}
                      onChangeValue={this.doChangeValue}
                      nameForm={this.state.nameForm}
                    />
                  </Row>
                  <Row>&nbsp; </Row>
                  <Row>
                    <InputForm
                      id={2}
                      width={12}
                      show={true}
                      // verify="number"
                      label=''
                      placeholder='Информация о судебных процессах'
                      description='Текущее состояние предприятия'
                      value={this.value[2] ? this.value[2].value : ''}
                      onChangeValue={this.doChangeValue}
                      nameForm={this.state.nameForm}
                    />
                  </Row>
                  <Row>&nbsp; </Row>
                  <Row>
                    <InputForm
                      id={3}
                      width={12}
                      show={true}
                      // verify="number"
                      label=''
                      placeholder='Информация о судебных процессах'
                      description='Текущее состояние предприятия'
                      value={this.value[3] ? this.value[3].value : ''}
                      onChangeValue={this.doChangeValue}
                      nameForm={this.state.nameForm}
                    />
                  </Row>
                  <Row> &nbsp; </Row>

                  <Row> &nbsp; </Row>
                </Form.Group>
              </Container>
              <AllModalsFooter
                footerContent={
                  //     <SaveButtonGreen
                  //     handleSaveClick={this.handleClickSave}
                  //     needDisable={false}
                  //     saveButtonText='Сохранить'
                  //   />
                  <SaveCurrentDataButton handleSaveClick={this.saveDataWithNotification} needDisable={false} savedDataMessage={this.state.savedDataMessage} buttonTextDefault={'Сохранить'} buttonTextSaved={'Данные сохранены'} needCustomIcon={false} />

                  // <Button
                  //     variant="success"
                  //     onClick={this.handleClickSave}
                  // >
                  //     Сохранить
                  // </Button>
                }
              />
            </div>
          </Form>
        </div>
      </>
    )
  }
}
